<template>
  <div class="wrapper pa-4">
    <!-- <img
      class="full-bleed-img"
      src="https://cdn.jsdelivr.net/gh/miloweimo/blogimage/fz.png"
      alt="题图"
    > -->
    <img
      class="full-bleed-img"
      src="https://cdn.jsdelivr.net/gh/miloweimo/blogimage/fzhr.jpg"
      alt="题图"
    >
    <h1>{{ $t('demo.hello') }}</h1>
    <p>😆</p>
    <p>这个demo 用于测试Vue相关技术</p>
    <p>{{ VUE_APP_VERSION }}</p>
    <hr>
    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sapiente animi consequatur adipisci expedita, deleniti asperiores corporis ducimus? Repellat laboriosam magni, dolore, modi reprehenderit eaque tenetur necessitatibus possimus ut, molestiae quae.</p>
    <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Optio quidem facere, nulla itaque asperiores, ipsam obcaecati vitae necessitatibus alias aliquam, aut est sint atque sed repudiandae esse. Magni, perferendis at.</p>
    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est, cumque debitis facilis quis itaque cum at, earum fugit cupiditate recusandae, pariatur ratione architecto dolore enim laboriosam eius. Provident, nesciunt unde.</p>
    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est, cumque debitis facilis quis itaque cum at, earum fugit cupiditate recusandae, pariatur ratione architecto dolore enim laboriosam eius. Provident, nesciunt unde.</p>
    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est, cumque debitis facilis quis itaque cum at, earum fugit cupiditate recusandae, pariatur ratione architecto dolore enim laboriosam eius. Provident, nesciunt unde.</p>
    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est, cumque debitis facilis quis itaque cum at, earum fugit cupiditate recusandae, pariatur ratione architecto dolore enim laboriosam eius. Provident, nesciunt unde.</p>
    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est, cumque debitis facilis quis itaque cum at, earum fugit cupiditate recusandae, pariatur ratione architecto dolore enim laboriosam eius. Provident, nesciunt unde.</p>
    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est, cumque debitis facilis quis itaque cum at, earum fugit cupiditate recusandae, pariatur ratione architecto dolore enim laboriosam eius. Provident, nesciunt unde.</p>
    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est, cumque debitis facilis quis itaque cum at, earum fugit cupiditate recusandae, pariatur ratione architecto dolore enim laboriosam eius. Provident, nesciunt unde.</p>
    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Est, cumque debitis facilis quis itaque cum at, earum fugit cupiditate recusandae, pariatur ratione architecto dolore enim laboriosam eius. Provident, nesciunt unde.</p>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      VUE_APP_VERSION: process.env.VUE_APP_VERSION
    }
  },
  computed: {
    ...mapState('demo', ['msg']),
  },
}
</script>

<style scoped>
.wrapper {
  display: grid;
  grid-template-columns:
    1fr
    min(65ch, 100%)
    1fr;
}

.wrapper > * {
  grid-column: 2;
}

.full-bleed {
  width: 100%;
  grid-column: 1 / -1;
}

.full-bleed-img {
  width: 100%;
  grid-column: 1 / -1;
  max-height: 40vh;
  object-fit:cover;
}

</style>